var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('div', {
    staticClass: "activity-container",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l(_vm.rounds, function (round, roundIndex) {
    return _c('div', {
      key: roundIndex,
      staticClass: "round-container",
      attrs: {
        "id": [("round-container-" + roundIndex)],
        "track-by": roundIndex
      }
    }, _vm._l(round.steps, function (step, stepIndex) {
      var _round$steps, _step$activityImage, _step$activityImage$i, _step$activityImage2, _step$activityImage2$;
      return ((_round$steps = round.steps[stepIndex - 1]) === null || _round$steps === void 0 ? void 0 : _round$steps.column) !== step.column ? _c('div', {
        key: (stepIndex + "-" + (step.answer)),
        class: ((!step.activityImage && !step.activityAudio ? 'tab-box' : 'step-box') + " round-" + roundIndex + "-step-" + stepIndex),
        attrs: {
          "id": [("round-" + roundIndex + "-step-" + stepIndex)],
          "track-by": roundIndex,
          "aria-hidden": "true"
        }
      }, [_c('div', {
        staticClass: "image-container"
      }, [_c('img', {
        staticClass: "image",
        attrs: {
          "alt": (_step$activityImage = step.activityImage) === null || _step$activityImage === void 0 ? void 0 : (_step$activityImage$i = _step$activityImage.image) === null || _step$activityImage$i === void 0 ? void 0 : _step$activityImage$i.description,
          "src": (_step$activityImage2 = step.activityImage) === null || _step$activityImage2 === void 0 ? void 0 : (_step$activityImage2$ = _step$activityImage2.image) === null || _step$activityImage2$ === void 0 ? void 0 : _step$activityImage2$.src
        }
      })]), _c('div', {
        staticClass: "answer-container"
      }, [_c('div', {
        staticClass: "answer",
        attrs: {
          "tabindex": "0"
        }
      }, [_c('blinking-cursor-text', {
        attrs: {
          "roundId": roundIndex,
          "text-step": stepIndex,
          "text": step.answer,
          "shouldBeCompletedStep": roundIndex < _vm.progress.roundIndex || stepIndex < _vm.progress.stepIndex
        }
      })], 1), _c('div', {
        staticClass: "tab"
      }, [_c('div', {
        staticClass: "svg-container"
      }, [_c('svg', {
        staticClass: "svg-elem",
        attrs: {
          "aria-label": "Tab key",
          "height": "67px",
          "role": "img",
          "width": "101px"
        },
        domProps: {
          "innerHTML": _vm._s(_vm.tabKeySVG)
        }
      })])])])]) : _vm._e();
    }), 0);
  }), 0)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }